import React, { useEffect } from "react";
import AppRoutes from "./data/app-routes";
import { LanguageProvider } from "./context/language-context";
import { Provider } from "react-redux";
import store from "./state/store";
import { AppProvider, UserProvider } from "./context";
import { StoreUtil } from "./utils/store";
import { SESSION_ISUSERLOOGED_KEY } from "./utils/constants";
import aesEncryptDecrypt from "./utils/aes.encrypt.decrypt";
import WindowPerformer from "./components/windows-performer";

const App: React.FC = () => {
  useEffect(() => {
    if (
      StoreUtil.get(SESSION_ISUSERLOOGED_KEY) !==
      aesEncryptDecrypt.encodeBase64("true").toString()
    ) {
      StoreUtil.removeAllCookies();
    }
  }, []);

  return (
    <>
      <LanguageProvider>
        <Provider store={store}>
          <AppProvider>
            <UserProvider>
              <WindowPerformer>
                <AppRoutes></AppRoutes>
              </WindowPerformer>
            </UserProvider>
          </AppProvider>
        </Provider>
      </LanguageProvider>
    </>
  );
};

export default App;
